import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import EncloseTable from "@shared/baseUI/EnhancedTable/EncloseTable";
import { TABLE_TRANSLATION_LIST } from "@utils/constants";

const PrepareDataTable = (props) => {
  const { t, isRefreshList, loading, data, setData, fetchRecords } = props;

  let columns = [
    {
      Header: t("TRANSLATION_FILE_NAME"),
      Title: "Filename",
      accessor: "file",
      // eslint-disable-next-line react/prop-types
      disableFilters: true,
    },
    {
      Header: t("TRANSLATION_UPLOAD_DATE"),
      Title: "createdAt",
      accessor: "uploadedAt",
      disableFilters: true,
    },
    {
      Header: t("TRANSLATION_CACHED_DATE"),
      Title: "updatedAt",
      accessor: "cachedAt",
      disableFilters: true,
    },
  ];

  // useEffect(() => {
  //   fetchRecords();
  // }, []);

  // useEffect(() => {
  //   getAdmins();
  // }, []);

  return (
    <EncloseTable
      type={TABLE_TRANSLATION_LIST}
      columns={columns}
      data={data}
      pageCount={1}
      initialPageSize={30}
      isRefreshDataAgain={isRefreshList}
      fetchRecords={fetchRecords}
      loading={loading}
      defaultSortOptions={[{ id: "id", desc: true, dir: "desc" }]}
    />
  );
};

PrepareDataTable.propTypes = {
  t: PropTypes.func.isRequired,
  isRefreshList: PropTypes.bool.isRequired,
  // objectId: PropTypes.number,
  updateRefeshStatus: PropTypes.func,
};
PrepareDataTable.defaultProps = {
  updateRefeshStatus: {},
};

export default withTranslation()(PrepareDataTable);
